import * as React from 'react';

const styles = require('./Panel.scss');

export default class Panel extends React.Component {
    public render() {
        return <div className={styles.className}>{this.props.children}</div>;
    }
}
